import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { MetricCardsSectionProps } from './types';
import { METRIC_CARDS_CONFIG, METRIC_TYPES, TREND_ICONS, SUPPORT_TICKETS_VALUE } from './constants';
import {
  MetricsGrid,
  MetricCardWrapper,
  MetricCardAccent,
  MetricCardTop,
  MetricCardInfo,
  MetricLabel,
  MetricValue,
  MetricSubtitle,
  MetricIconBox,
  MetricTrendRow,
  TrendIndicator,
  TrendBadge,
} from './styles';
import MetricCardSkeleton from './MetricCardSkeleton';

const MetricCardsSection: React.FC<MetricCardsSectionProps> = ({
  totalMerchants,
  activeDevices,
  isLoading,
  selectedItem,
  onTileClick,
}) => {
  const metricValues: Record<string, string | number> = {
    [METRIC_TYPES.TOTAL_MERCHANTS]: totalMerchants,
    [METRIC_TYPES.ACTIVE_DEVICES]: activeDevices,
    [METRIC_TYPES.SUPPORT_TICKETS]: SUPPORT_TICKETS_VALUE,
  };
  if (isLoading) {
    return (
      <MetricsGrid>
        <MetricCardSkeleton />
        <MetricCardSkeleton />
        <MetricCardSkeleton />
      </MetricsGrid>
    );
  }

  return (
    <MetricsGrid>
      {METRIC_CARDS_CONFIG.map((config) => {
        const value = metricValues[config.key] ?? 0;
        const isPositive = config.trend === 'up';

        return (
          <MetricCardWrapper
            key={config.key}
            $isSelected={selectedItem === config.key}
            $accentColor={config.iconColor}
            onClick={() => onTileClick(config.key)}
          >
            <MetricCardAccent $color={config.iconColor} />
            <MetricCardTop>
              <MetricCardInfo>
                <MetricLabel>{config.title}</MetricLabel>
                <MetricValue $color={config.iconColor}>{value}</MetricValue>
                <MetricSubtitle>{config.subtitle}</MetricSubtitle>
              </MetricCardInfo>
              <MetricIconBox $color={config.iconColor}>
                <FontAwesomeIcon icon={config.icon} />
              </MetricIconBox>
            </MetricCardTop>
            <MetricTrendRow>
              <TrendIndicator $isPositive={isPositive}>
                <FontAwesomeIcon icon={TREND_ICONS[config.trend]} />
                {config.trendValue}
              </TrendIndicator>
              <TrendBadge
                $isPositive={isPositive}
                color={isPositive ? 'success' : 'error'}
              >
                {isPositive ? 'Active' : 'Inactive'}
              </TrendBadge>
            </MetricTrendRow>
          </MetricCardWrapper>
        );
      })}
    </MetricsGrid>
  );
};

export default MetricCardsSection;
